module.exports = "/_next/static/images/OgImage-47687cae91c33c371433ba1d30268464.jpg";